import firebase from 'firebase';

export const fetchStaticTextsIfNecessary = () => {
    return async (dispatch, getState) => {

        if (getState().staticTexts.fetched)  return;

        dispatch({type: "FETCH_STATIC_TEXTS"});

        // await firebase.firestore().collection("newsletter")
        //     .get().then(snapshot => {
        //         let items = [];
        //         snapshot.forEach(doc => {
        //             const item = doc.data();
        //             console.log({...item, id: doc.id});
        //             items.push(item.mail);
        //         });
        //         console.log(items);
        //         console.log(items.join("; "));
        //     });
        
        let items = await firebase.firestore().collection("static")
            .get().then(snapshot => {
            let items = [];
            snapshot.forEach(doc => {
                const item = doc.data();
                item.id = doc.id;
                items.push(item);
            });
                return items;
        });

        dispatch({
            type: "FETCHED_STATIC_TEXTS", payload: {
                items
            }
        })



    };
};

export const save = (text) => {

    return async (dispatch) => {

        dispatch({type: "SAVE_STATIC_TEXT"});

        let items = await firebase.firestore().collection("static").doc(text.id).set(text);

        dispatch({
            type: "SAVED_STATIC_TEXT", payload: text
        })



    };
};

export const saveNewsletterMail = (text) => {

    return async (dispatch) => {
        dispatch({type: "SAVING_NEWSLETTER"});
        firebase.firestore().collection("newsletter").add({
            createdAt: new Date(),
            mail:text
        }).then(() => {
            dispatch({
                type: "SAVED_NEWSLETTER", payload: text
            })
        });

    };
};


// WEBPACK FOOTER //
// ./src/actions/StaticActions.js